export enum Campaign {
    giftOfHealth2026 = 'gift-of-health-2026',
}